const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M27.36 26.912c-6.048 6.080-16.64 5.504-22.56-0.416-6.080-6.080-6.4-15.808-0.896-22.24 0.352-0.416 0.672-0.832 1.12-1.088 1.152-0.736 2.72-0.576 3.744 0.416 0.96 0.992 1.12 2.432 0.512 3.584-0.16 0.288-0.288 0.48-0.512 0.704-4.48 4.832-4.64 12.128-0.256 16.512 4.896 4.896 13.024 3.872 17.344-1.088 3.392-3.904 4.544-9.504 2.464-14.432-2.656-6.336-9.76-9.312-16.32-7.104v-0.032c7.552-2.624 15.744 0.768 18.816 8.064 2.272 5.344 1.184 11.36-2.304 15.776-0.352 0.48-0.736 0.928-1.152 1.344z"
});

const SvgSpin = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-spin",
    viewBox: "0 0 32 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/spin.c5c7d677.svg";
export { ForwardRef as ReactComponent };